import React from 'react';
import { Box } from '@mui/material';
import { marketingColors as C, marketingFonts as F } from '../../theme_landing_page';
import type { ContentSection } from '../data/types';

const calloutTone: Record<string, [string, string]> = {
  info: [C.tintBlue, 'rgba(0,84,249,0.15)'],
  warn: [C.calloutWarnBg, C.calloutWarnBorder],
  success: [C.calloutSuccessBg, C.calloutSuccessBorder],
};

const ArticleBody: React.FC<{ sections: ContentSection[] }> = ({ sections }) => (
  <Box
    className="lv-prose"
    sx={{
      '& p': { fontSize: 17, lineHeight: 1.75, color: C.proseText, marginBottom: '20px' },
      '& a': { color: C.accent, textDecoration: 'underline' },
    }}
  >
    {sections.map((s) => (
      <Box key={s.id}>
        <Box
          component="h2"
          id={s.id}
          sx={{ fontFamily: F.display, fontWeight: 400, fontSize: 32, lineHeight: 1.15, letterSpacing: '-0.02em', margin: '40px 0 18px', scrollMarginTop: '100px' }}
        >
          {s.heading}
        </Box>
        {s.blocks.map((b, i) => {
          if (b.kind === 'p') return <p key={i}>{b.text}</p>;
          if (b.kind === 'ul' || b.kind === 'ol') {
            return (
              <Box key={i} sx={{ display: 'flex', flexDirection: 'column', gap: '12px', margin: '0 0 24px' }}>
                {b.items.map((it, j) => (
                  <Box key={j} sx={{ display: 'flex', gap: '12px', alignItems: 'flex-start', fontSize: 17, lineHeight: 1.65, color: C.proseText }}>
                    <Box component="span" sx={{ flex: 'none', color: C.accent, fontWeight: 600, minWidth: 18 }}>
                      {b.kind === 'ol' ? `${j + 1}.` : '•'}
                    </Box>
                    {it}
                  </Box>
                ))}
              </Box>
            );
          }
          if (b.kind === 'quote') {
            return (
              <Box
                key={i}
                component="blockquote"
                sx={{ borderLeft: `4px solid ${C.accent}`, padding: '6px 22px', margin: '0 0 24px', fontFamily: F.display, fontSize: 24, lineHeight: 1.35, color: C.ink }}
              >
                {b.text}
              </Box>
            );
          }
          if (b.kind === 'callout') {
            const [bg, border] = calloutTone[b.tone || 'info'];
            return (
              <Box key={i} sx={{ background: bg, border: `1px solid ${border}`, borderRadius: '16px', padding: '18px 22px', margin: '0 0 24px', fontSize: 15.5, lineHeight: 1.6, color: C.proseText }}>
                {b.text}
              </Box>
            );
          }
          return null;
        })}
      </Box>
    ))}
  </Box>
);

export default ArticleBody;
